











































import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import { share, getAreas } from '../api';
import PickerInput from '@/components/PickerInput.vue';
@Component({
  components: {
    VoteList,
    PickerInput,
  },
})
export default class Home extends Vue {
  active = 0;
  tempValue = '';
  searchWords: string = '';
  pickerData: any[] = [];
  county = 1;
  tabs = [
    { line01: '“俭以养德”', line02: '家风故事' },
    { line01: '“记住乡愁”', line02: '农耕体验' },
    { line01: '“吃得文明”', line02: '光盘行动' },
  ];
  get mapName() {
    return this.pickerData.map((item) => item.name);
  }
  created() {
    share(this);
    getAreas().then((res: any) => {
      const temp = Object.keys(res.data).map((item) => {
        return {
          name: res.data[item],
          id: item,
        };
      });
      this.pickerData = temp;
    });
  }
  selectData(e: any) {
    this.county = this.pickerData.filter((item) => item.name === e)[0].id;
  }
  handleClickTab(index: number) {
    this.tempValue = '';
    this.searchWords = '';
    this.active = index;
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
    // this.searchWords = (this.$refs.input as HTMLInputElement).value;
  }
  enterDetailPage(id: number) {
    this.$router.push({
      path: 'detail',
      query: {
        id: String(id),
        type: String(this.active + 1),
      },
    });
  }

  jumpToUserCenter() {
    this.$router.push({
      path: 'user',
    });
  }
}
